import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";

const dbConfig = {
	apiKey: "AIzaSyAZAoVL_RZO56DAX24OZYY7UeBm82TisBs",
	authDomain: "fresk-402022.firebaseapp.com",
	projectId: "fresk-402022",
	storageBucket: "fresk-402022.firebasestorage.app",
	messagingSenderId: "840270936799",
	appId: "1:840270936799:web:3a0d9142305fc6becd476a"
};

const app = initializeApp(dbConfig);

const dbId = process.env.VUE_APP_DATABASE_ID;

export const db =
	dbId?.length
		? initializeFirestore(app, {}, dbId)
		: initializeFirestore(app, {});

export const auth = getAuth(app);
